/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTITLE } from './IAPTITLE';
import {
    IAPTITLEFromJSON,
    IAPTITLEFromJSONTyped,
    IAPTITLEToJSON,
} from './IAPTITLE';

/**
 * 
 * @export
 * @interface ContactPersonViewModel
 */
export interface ContactPersonViewModel {
    /**
     * 
     * @type {string}
     * @memberof ContactPersonViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonViewModel
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonViewModel
     */
    designation?: string;
    /**
     * 
     * @type {IAPTITLE}
     * @memberof ContactPersonViewModel
     */
    titleId?: IAPTITLE;
}

/**
 * Check if a given object implements the ContactPersonViewModel interface.
 */
export function instanceOfContactPersonViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactPersonViewModelFromJSON(json: any): ContactPersonViewModel {
    return ContactPersonViewModelFromJSONTyped(json, false);
}

export function ContactPersonViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPersonViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'designation': !exists(json, 'Designation') ? undefined : json['Designation'],
        'titleId': !exists(json, 'TitleId') ? undefined : IAPTITLEFromJSON(json['TitleId']),
    };
}

export function ContactPersonViewModelToJSON(value?: ContactPersonViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstName': value.firstName,
        'Initials': value.initials,
        'Surname': value.surname,
        'Designation': value.designation,
        'TitleId': IAPTITLEToJSON(value.titleId),
    };
}

